import { PromoLabelEnum } from "../../@enum/store/promo-rule-type/promo-rule-type.enum";

export type TIsVoucherPromotionOutput = boolean;

export const isVoucherPromotion = (
  label: PromoLabelEnum
): TIsVoucherPromotionOutput => {
  return [
    PromoLabelEnum.ORDER_VOUCHER,
    PromoLabelEnum.PRODUCT_VOUCHER,
  ].includes(label);
};
